// extracted by mini-css-extract-plugin
module.exports = {"iconButton":"icon-button_iconButton__2rvoe","icon":"icon-button_icon__1Fk-I"};